import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { anchorId } from '../settings-tabs';

const FOCUSABLE = 'button, select, input, textarea, [tabindex]:not([tabindex="-1"])';

/**
 * Wijst het adres een plek op dit tabblad aan (`#nhg-ingeschreven-als`), dan komt
 * die plek in beeld en krijgt het veld erin de focus: wie op de link klikte, kan
 * met het toetsenbord meteen verder. `ready` zegt of de kaart met die plek er al
 * staat; tot dan wacht het.
 *
 * Zonder animatie: het tabblad verschijnt, de plek staat in beeld.
 */
export function useFocusOnHash(ready: boolean): void {
    const { hash, key } = useLocation();

    useEffect(() => {
        if (!ready || hash.length < 2) {
            return;
        }

        const target = document.getElementById(anchorId(hash));

        if (!target) {
            return;
        }

        target.scrollIntoView?.({ block: 'center' });

        const control = target.matches(FOCUSABLE)
            ? target
            : target.querySelector<HTMLElement>(FOCUSABLE);

        control?.focus({ preventScroll: true });
    }, [ready, hash, key]);
}
